var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custorm-table-title"},[_c('div',[_vm._v(_vm._s(_vm.title)+_vm._s(_vm.subTitle))]),_c('div',[_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }